import { ArrayFilterPipe } from './pipes/filter-by.pipe';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectDropDownComponent } from "./components/ngx-select-dropdown-component/ngx-select-dropdown.component";
import { ClickOutsideModule } from 'ng-click-outside';

@NgModule({
  declarations: [SelectDropDownComponent, LimitToPipe, ArrayFilterPipe],
  imports: [CommonModule, FormsModule, ClickOutsideModule],
  exports: [SelectDropDownComponent, LimitToPipe , ClickOutsideModule],
  providers: [],
  bootstrap: []
})
export class CustomSelectDropDownModule { }
